<template>
  <div :class="$b()">
    <ShippingTimer
      :data="customisedProduct"
    />
  </div>
</template>

<script>
export default {
  name: 'ShippingConvincer',

  props: {
    customisedProduct: {type: Object, default: () => {}}
  }
}
</script>

<style lang="postcss">
.ShippingConvincer {
  @apply relative w-full;

  @screen md {
    @apply flex items-center space-x-xxs;
  }
}
</style>
